interface AppConfig {
	ENABLE_PAYMENTS: boolean
	REDIRECT_PAYMENTS_TO_LOCALHOST: boolean
	THEIA_LOCAL_CONNECTION: boolean
	THEIA_CONFIG_HOME: string
	QUICKSTART_WIDGET_FILE: string
}

// Validate required environment variables
const validateEnv = () => {
	const requiredEnvs = {
		ENABLE_PAYMENTS: process.env.ENABLE_PAYMENTS,
		REDIRECT_PAYMENTS_TO_LOCALHOST: process.env.REDIRECT_PAYMENTS_TO_LOCALHOST,
		THEIA_LOCAL_CONNECTION: process.env.THEIA_LOCAL_CONNECTION,
		THEIA_CONFIG_HOME: process.env.THEIA_CONFIG_HOME,
		QUICKSTART_WIDGET_FILE: process.env.QUICKSTART_WIDGET_FILE
	}

	Object.entries(requiredEnvs).forEach(([key, value]) => {
		if (!value) {
			// eslint-disable-next-line no-console
			console.warn(
				`Missing required environment variable: ${key}. Will use default value.`
			)
		}
	})
}

// Load environment variables with defaults
const loadConfig = (): AppConfig => {
	// Validate environment variables before loading the config
	validateEnv()

	return {
		ENABLE_PAYMENTS: process.env.ENABLE_PAYMENTS === 'true',
		REDIRECT_PAYMENTS_TO_LOCALHOST:
			process.env.REDIRECT_PAYMENTS_TO_LOCALHOST === 'true',
		THEIA_LOCAL_CONNECTION: process.env.THEIA_LOCAL_CONNECTION === 'true',
		THEIA_CONFIG_HOME: process.env.THEIA_CONFIG_HOME || 'THEIA_CONFIG_HOME',
		QUICKSTART_WIDGET_FILE:
			process.env.QUICKSTART_WIDGET_FILE || 'quickstart-widget-state'
	}
}

export const config = loadConfig()
